import { styled } from '@mui/material'

export const CodeOutput = styled('pre')({
  backgroundColor: '#d3d3d3',
  color: '#313131',
  padding: 2,
  fontSize: '1.4rem',
  whiteSpace: 'pre-wrap',
})
